import { useContext } from 'react';
import { SupportContext } from '../../contexts/support-context';
import type { SupportContextValue } from '../../types/support.types';

/**
 * Accesses the authenticated layout's support session.
 * @returns Shared help actions and unread state.
 * @throws When mounted outside SupportProvider.
 */
export function useSupport(): SupportContextValue {
  const value = useContext(SupportContext);
  if (!value) throw new Error('useSupport requires SupportProvider');
  return value;
}
